module.exports = __webpack_public_path__ + "media/images/athletes/3600-6d6bfa3c3838ea6317a588a0e0fd8bc6.png";